$(document).ready(function(){

  function setupContinueSellingStatus() {
    var $productForm = $('form.product-single__form').first();
    var formId = $productForm.attr('id') || '';
    var sectionId = formId.replace('AddToCartForm-', '');
    var $variantsJson = sectionId ? $('#VariantsJson-' + sectionId) : $('[id^="VariantsJson-"]').first();
    var $inventoryPolicyJson = sectionId ? $('#VariantInventoryPolicyJson-' + sectionId) : $('[id^="VariantInventoryPolicyJson-"]').first();

    if (!$productForm.length) {
      console.log('[ContinueSelling] Product form not found.');
      return;
    }

    if (!$variantsJson.length) {
      console.log('[ContinueSelling] Variants JSON not found for section:', sectionId);
      return;
    }

    var variants = [];
    var inventoryPolicyByVariantId = {};
    var isPolicyMapLoaded = false;
    try {
      variants = JSON.parse($variantsJson.text());
      console.log('[ContinueSelling] Loaded variants:', {
        formId: formId,
        sectionId: sectionId,
        variantsCount: variants.length
      });
    } catch (e) {
      console.log('[ContinueSelling] Failed to parse variants JSON:', e);
      return;
    }

    function getProductHandleFromPath() {
      var match = window.location.pathname.match(/\/products\/([^\/\?#]+)/i);
      return match && match[1] ? match[1] : null;
    }

    function buildPolicyMapFromVariants(list) {
      list.forEach(function(item) {
        if (item && item.id && typeof item.inventory_policy !== 'undefined') {
          inventoryPolicyByVariantId[String(item.id)] = item.inventory_policy;
        }
      });
    }

    buildPolicyMapFromVariants(variants);

    if ($inventoryPolicyJson.length) {
      try {
        var policyList = JSON.parse($inventoryPolicyJson.text());
        buildPolicyMapFromVariants(policyList);
        console.log('[ContinueSelling] Loaded policy map from Liquid JSON:', {
          mappedPolicies: Object.keys(inventoryPolicyByVariantId).length
        });
      } catch (e) {
        console.log('[ContinueSelling] Failed to parse Liquid policy JSON:', e);
      }
    } else {
      console.log('[ContinueSelling] Liquid policy JSON block not found for section:', sectionId);
    }

    function loadInventoryPoliciesIfNeeded(callback) {
      if (Object.keys(inventoryPolicyByVariantId).length > 0 || isPolicyMapLoaded) {
        if (typeof callback === 'function') {
          callback();
        }
        return;
      }

      var handle = getProductHandleFromPath();
      if (!handle) {
        console.log('[ContinueSelling] Could not detect product handle from URL.');
        isPolicyMapLoaded = true;
        if (typeof callback === 'function') {
          callback();
        }
        return;
      }

      $.getJSON('/products/' + handle + '.js')
        .done(function(productData) {
          if (productData && productData.variants && productData.variants.length) {
            buildPolicyMapFromVariants(productData.variants);
          }
          console.log('[ContinueSelling] Loaded policy map from /products/' + handle + '.js', {
            mappedPolicies: Object.keys(inventoryPolicyByVariantId).length
          });
        })
        .fail(function(err) {
          console.log('[ContinueSelling] Failed to load /products/' + handle + '.js', err);
        })
        .always(function() {
          isPolicyMapLoaded = true;
          if (typeof callback === 'function') {
            callback();
          }
        });
    }

    function getSelectedVariant() {
      var selectedId = parseInt($productForm.find('[name="id"]').val(), 10);
      var selectedVariant = variants.find(function(variant) {
        return parseInt(variant.id, 10) === selectedId;
      });
      console.log('[ContinueSelling] Selected variant lookup:', {
        selectedId: selectedId,
        found: !!selectedVariant,
        title: selectedVariant ? selectedVariant.title : null,
        inventory_policy: selectedVariant ? selectedVariant.inventory_policy : null
      });
      return selectedVariant;
    }

    function renderContinueSellingStatus() {
      var variant = getSelectedVariant();
      if (!variant) {
        console.log('[ContinueSelling] No variant matched current selected id.');
        return;
      }

      var policy = variant.inventory_policy;
      if (typeof policy === 'undefined') {
        policy = inventoryPolicyByVariantId[String(variant.id)];
      }
      var isContinueSellingOn = policy === 'continue';
      var statusText = isContinueSellingOn ? '' : '';
      console.log('[ContinueSelling] Render status:', {
        variantId: variant.id,
        variantTitle: variant.title,
        inventory_policy: policy,
        source: typeof variant.inventory_policy !== 'undefined' ? 'variantsJson' : 'productJsFallback',
        statusText: statusText
      });
      var $status = $('.continue-selling-status');

      if (!$status.length) {
        var $inventory = $('.product__inventory').first();
        if ($inventory.length) {
          $inventory.after('<div class="continue-selling-status"></div>');
          $status = $('.continue-selling-status');
        }
      }

      if ($status.length) {
        $status.text(statusText);
      }

      $productForm.attr('data-continue-selling-on', isContinueSellingOn ? 'true' : 'false');
      $productForm.attr('data-selected-variant-id', String(variant.id));
    }

    renderContinueSellingStatus();
    loadInventoryPoliciesIfNeeded(renderContinueSellingStatus);

    if (!$productForm.data('continue-selling-status-bound')) {
      $productForm.on('variantChange', function() {
        console.log('[ContinueSelling] variantChange event fired');
        setTimeout(renderContinueSellingStatus, 0);
      });

      $productForm.on('change', '[name="id"]', function() {
        console.log('[ContinueSelling] [name="id"] change event fired. New value:', $(this).val());
        setTimeout(renderContinueSellingStatus, 0);
      });

      $productForm.on('change', '.variant-input-wrap input, .variant-input-wrap select', function() {
        console.log('[ContinueSelling] Variant option changed:', {
          name: $(this).attr('name'),
          value: $(this).val(),
          type: $(this).attr('type')
        });
        setTimeout(renderContinueSellingStatus, 0);
      });

      $productForm.data('continue-selling-status-bound', true);
    }
  }

  setupContinueSellingStatus();

  $('.variant-input-wrap input[type="radio"]').change(function(){
    var getValue = $('input[name="Type"]:checked').val();

    if(getValue == 'Swatch'){

      $('.add-to-cart span').text('Order Swatch');
    }else{
      $('.add-to-cart span').text('Buy Now');
    }

  }); 

  var productType = $('.product__inventory').attr('data-product-type');
  var backorderApproved = false;

  function getContinueSellingState() {
    return $('form.product-single__form').first().attr('data-continue-selling-on') === 'true';
  }

  function clearQuantityErrors() {
    $('.product-single__form .errors').remove();
  }

  function disableAddToCart() {
    $('.add-to-cart').attr('disabled', 'disabled');
  }

  function enableAddToCart() {
    $('.add-to-cart').removeAttr('disabled');
  }

  function getMaxYardageError(productAvailability, errorNote) {
    if (productType == 'prints') {
      return 'Max yardage available is (' + productAvailability + ' yds). Please lower quantity ordered. <br>' + errorNote;
    }
    return 'Max yardage available is (' + productAvailability + ' yds). Please lower quantity ordered.';
  }

  function showMaxYardageError(productAvailability, errorNote) {
    clearQuantityErrors();
    disableAddToCart();
    $('.product-single__form').prepend('<div class="errors text-center">' + getMaxYardageError(productAvailability, errorNote) + '</div>');
  }

  function showBackorderChoice() {
    clearQuantityErrors();
    disableAddToCart();
    $('.product-single__form').prepend(
      '<div class="errors text-center backorder-choice"><p class="confirmation_massage">Goods are back-ordered 2-3 weeks. Do you wish to continue with the purchase order? </p>' +
      '<button type="button" class="btn backorder-yes" style="margin-left:8px;">Yes</button> ' +
      '<button type="button" class="btn backorder-no" style="margin-left:6px;">No</button>' +
      '</div>'
    );
  }

  function showBackorderResponseMessage(message) {
    $('.product-single__form .backorder-choice').remove();
    $('.product-single__form').prepend('<div class="errors text-center backorder-response">' + message + '</div>');
  }

  function validatePdpQuantity(nextQuantity) {
    var getQuantity = typeof nextQuantity === 'number' ? nextQuantity : parseInt($('.product__quantity .js-qty__num').val(), 10);
    var $inventoryEl = $('.product__inventory');
    var inventoryTracked = $inventoryEl.attr('data-inventory-tracked') === 'true';
    var productAvlailabilty = parseInt($inventoryEl.attr('data-availability'), 10);
    var errorNote = $inventoryEl.attr('data-note');
    var continueSellingOn = getContinueSellingState();

    if (isNaN(getQuantity) || isNaN(productAvlailabilty)) {
      return;
    }

    // Only validate quantity if inventory is actually tracked
    if (!inventoryTracked) {
      clearQuantityErrors();
      enableAddToCart();
      return;
    }

    if (getQuantity > productAvlailabilty) {
      if (continueSellingOn) {
        if (backorderApproved) {
          clearQuantityErrors();
          enableAddToCart();
        } else {
          showBackorderChoice();
        }
      } else {
        showMaxYardageError(productAvlailabilty, errorNote);
      }
    } else {
      backorderApproved = false;
      clearQuantityErrors();
      enableAddToCart();
    }
  }

  $('.product__quantity .js-qty__num').change(function(){
    backorderApproved = false;
    validatePdpQuantity();
  });

  $('.js-qty__adjust--plus').click(function(){
    var getQuantity = parseInt($('.product__quantity .js-qty__num').val(), 10);
    backorderApproved = false;
    validatePdpQuantity(getQuantity + 1);
  });

  $('.js-qty__adjust--minus').click(function(){
    var getQuantity = parseInt($('.product__quantity .js-qty__num').val(), 10);
    backorderApproved = false;
    validatePdpQuantity(getQuantity - 1);
  });

  $('form.product-single__form').on('click', '.backorder-yes', function() {
    backorderApproved = true;
    enableAddToCart();
    showBackorderResponseMessage('You can continue with Buy Now.');
  });

  $('form.product-single__form').on('click', '.backorder-no', function() {
    backorderApproved = false;
    disableAddToCart();
    showBackorderResponseMessage('Thanks for visiting! Feel free to explore more products.');
  });

  $('form.product-single__form').on('variantChange change', '[name="id"], .variant-input-wrap input, .variant-input-wrap select', function() {
    backorderApproved = false;
    setTimeout(function() {
      validatePdpQuantity();
    }, 0);
  });

  $('.cart__row .cart__product-qty').change(function(){
    var productType = $(this).attr('data-product-type');
    var getQuantity = $(this).val();
    getQuantity = parseInt(getQuantity);
    var productAvlailabilty = $(this).attr('data-availability');
    productAvlailabilty = parseInt(productAvlailabilty);

    if(getQuantity > productAvlailabilty){
      $('.cart__row .errors').remove();
      $('.cart__checkout-wrapper button').attr('disabled','disabled');
      if(productType == 'prints'){
        console.log(getQuantity);
        $(this).parents('.cart__row').prepend('<div class="errors text-center">Max yardage available is ('+productAvlailabilty+' yds). Please lower quantity ordered. <br>note: item will not be re-stocked once sold out</div>');
      }else{
        $(this).parents('.cart__row').prepend('<div class="errors text-center">Max yardage available is ('+productAvlailabilty+' yds). Please lower quantity ordered.</div>');
      }
    } else{
      $('.cart__checkout-wrapper button').removeAttr('disabled','disabled');
      $('.cart__row .errors').remove();
    }
  });

  if($(window).width() < 769){
    $('.collection-sidebar .pricing-rang-slider-wrap').remove();
  }else{
    $('.drawer .pricing-rang-slider-wrap').remove();
  }

  $.ajax({
    url: 'https://www.worldlinen.com/blog/rss.xml',
    type: 'GET',
    dataType: "xml"
  }).done(function(data) {            
    var html = '';            
    $(data).find("item").each(function(i,val){
      if(i < 3)
      {       
        var publish_date = $(this).find('pubDate').text();
        var desc = $(this).find('description').text();
        var desc2= desc.replace(/(<([^>]+)>)/ig,"");
        var link = $(this).find('link').text();
        var title = $(this).find('title').text();
        var pubDate = new Date(publish_date);
        pubDate = pubDate.format("mmm ddS yyyy"); 

        html += '<div class="grid__item medium-up--one-third aos-init aos-animate" data-aos="row-of-3">'
        html += '<div class="grid">'
        html += '<div class="grid__item small--one-third">'
        html += '<a href="'+link+'" class="article__grid-image">'
        html += '<div class="image-wrap">'
        html += '<div class="grid__image-ratio grid__image-ratio--cover grid__image-ratio--wide lazyloaded">'
        html += '</div>'
        html += ' </div>'
        html += ' </a>'
        html += '</div>'
        html += '<div class="grid__item small--two-thirds">'
        html += '<div class="article__grid-meta">'
        html += '<div class="article__date">'
        html += '<time datetime="'+pubDate+'">'+pubDate+'</time>'
        html += '</div>'
        html += ' <a href="'+link+'" class="article__title">'+title+'</a>'
        html += '</div>'
        html += '</div>'
        html += '</div>'
        html += '<div class="post-summary" style="display:none"> '+desc +' </div>';
        html += '</div>'
      }
    });

    $('.import-blog').html(html);
    $('.import-blog .grid__item').each(function(){
      var path = $(this).find('.post-summary img.hs-featured-image').attr('src');
      if(path){
        $(this).find('.lazyloaded').css('background-image', 'url(' + path + ')');
      }
    });
  });

  $('.tab-slider').slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 500,
    cssEase: 'linear'
  });

  $('ol.tabs li:first-child').addClass('active');
  $('.tab-content:first').show();


  $('ol.tabs li').click(function(){
    $('ol.tabs li').removeClass('active');
    $(this).addClass('active');

    var slideNo = $(this).attr('data-index');    
    $('.tab-slider').slick('slickGoTo', slideNo);
  });

  $(".tab-slider").on("afterChange", function (event, slick, currentSlide, nextSlide){


    $('ol.tabs li').removeClass('active');
    $('ol.tabs li[data-index="'+currentSlide+'"]').addClass('active');
  })




  equalheight('.megamenu .grid__item.medium-up--one-fifth');
  equalheight('.megamenu .grid__item.medium-up--one-fifth .h5');
  equalheight('.megamenu .grid__item.medium-up--one-fifth .site-nav__dropdown-link');


  

  var classLength = $('.fabric-section').length;
  if(classLength){
    $('body').addClass('custom-service');
  }

//   $('.product-slider-main-wrap').slick({
//     dots: false,
//     arrows: false,
//     infinite: false,
//       adaptiveHeight: true
//   });
  

//   $('.product-slider-main-wrap').slick({
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     arrows: false,
//     dots:false,
//     asNavFor: '.product-thumb-slider'
//   });
//   $('.product-thumb-slider').slick({
//     slidesToShow: 8,
//     slidesToScroll: 1,
//     infinite: false,
//     asNavFor: '.product-slider-main-wrap'
//   });
  
  /* Pillar Page Code Start */
  $('.show-mobile-navigation').click(function(){
    $(".scroll-box").toggleClass( "mobile-scroll-box" );
    $(".show-mobile-navigation").toggleClass( "arrow" );
    $("body").toggleClass( "mobile-scroll-hide" );
  });

  $('.pillar-sidebar li a').click(function(){
    $(".scroll-box").toggleClass( "mobile-scroll-box" );
    $(".show-mobile-navigation").toggleClass( "arrow" );
    $("body").toggleClass( "mobile-scroll-hide" );
  });
  $(window).on('scroll', function () {
    if ($(window).scrollTop() > 150) {
      $( "#show-mobile-navigation" ).addClass( "is-visible" );
    } else {
      $( "#show-mobile-navigation" ).removeClass( "is-visible" );
      $(".scroll-box").removeClass( "mobile-scroll-box" );
      $(".show-mobile-navigation").removeClass( "arrow" );
    }
  });
  
  $('.Evoque_pillar-moduleV1 .pillar-sidebar ul li a').on('click', function(event) {
    var target = $(this.getAttribute('href'));
    if( target.length ) {
      event.preventDefault();
      $('html, body').stop().animate({
        scrollTop: target.offset().top
      }, 1000);
    }
  });
  
  var sections = $('.pillar-right-contentss section'),
      nav = $('.pillar-sidebar'), 
      nav_height = nav.outerHeight();
  
  $(window).on('scroll', function () {
    var cur_pos = $(this).scrollTop();

    sections.each(function() {
      var top = $(this).offset().top - nav_height,
          bottom = top + $(this).outerHeight();

      if (cur_pos >= top && cur_pos <= bottom) {
        nav.find('a').removeClass('active');
        sections.removeClass('active');

        $(this).addClass('active');
        nav.find('a[href="#'+$(this).attr('id')+'"]').addClass('active');
      }
    });
    
    if ($('.Evoque_formModule_v1')?.isInViewport()) {
      $('.Evoque_pillar-moduleV1 .span3.pillar-left-bar').css('height','auto');  
    }else{
      $('.Evoque_pillar-moduleV1 .span3.pillar-left-bar').css('height','0px');  
    } 
    
  });
  
  
  /* Pillar Page Code End */
  
  
});
const target = document.getElementById('CartDrawer');

if (target) {
  let lastState = target.classList.contains('drawer--is-open');
  let debounceTimeout = null;

  const observer = new MutationObserver(function(mutations) {
    for (const mutation of mutations) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        clearTimeout(debounceTimeout);

        debounceTimeout = setTimeout(() => {
          const isOpen = target.classList.contains('drawer--is-open');
          if (isOpen !== lastState) {
            lastState = isOpen;

            if (isOpen) {
              $('.ajaxcart__product').each(function(){
                const name = $(this).find('.ajaxcart__product-name').text();
                name?.includes('OUTLET') ? $(this).find('.order-over-free').remove(): '';
              })
              // your open logic here
            } else {
              console.log('Cart drawer closed');
              // your close logic here
            }
          }
        }, 50); // small debounce
      }
    }
  });

  observer.observe(target, {
    attributes: true,
    attributeFilter: ['class'],
  });
}


function cutString(s, n)
{
  var cut= s.indexOf(' ', n);
  if(cut== -1) return s;
  return s.substring(0, cut)
}
$(window).resize(function(){
  equalheight('.megamenu .grid__item.medium-up--one-fifth');
  equalheight('.megamenu .grid__item.medium-up--one-fifth .h5');
  equalheight('.megamenu .grid__item.medium-up--one-fifth .site-nav__dropdown-link');
  equalheight('.article__grid-meta');
  setTimeout(() => {
    equalheight('.grid-product__meta');
  }, 1000);
});	

$(window).load(function(){
  $('.variant-input-wrap input[type="radio"]').change(function(){
    var getValue = $('input[name="Type"]:checked').val();

    if(getValue == 'Swatch'){

      $('.add-to-cart span').text('Order Swatch');
    }else{
      $('.add-to-cart span').text('Buy Now');
    }

  }); 
  equalheight('.megamenu .grid__item.medium-up--one-fifth');
  equalheight('.megamenu .grid__item.medium-up--one-fifth .h5');
  equalheight('.megamenu .grid__item.medium-up--one-fifth .site-nav__dropdown-link');
   equalheight('.article__grid-meta');
   
  setTimeout(() => {
    equalheight('.grid-product__meta');
  }, 1000);

  $('.fabric-btns a').click(function(e){
    var index = $(this).index();
    index = index ;
    e.preventDefault();
    $('html, body').animate({
      scrollTop: $('.fabric-row').eq(index).offset().top
    }, 2000);
  });
  $('.request-btn').click(function(e){
    e.preventDefault();
    $('html, body').animate({
      scrollTop: $('.request-frm').offset().top
    }, 2000);
  });

});

$(function() {
  var $slider = $(".slider-range");
  var priceMin = 1,
      priceMax = 200;

  $(".min_price, .max_price").map(function(){
    $(this).attr({
      "min": priceMin,
      "max": priceMax
    });
  });
  $(".min_price").attr({
    "placeholder": priceMin,
    "value": priceMin
  });
  $(".max_price").attr({
    "placeholder":  + priceMax,
    "value": priceMax
  });

  $slider.slider({
    range: true,
    min: Math.max(priceMin, 0),
    max: priceMax,
    values: [priceMin, priceMax],
    slide: function(event, ui) {         
      $(".min_price").val(ui.values[0]);
      $(".max_price").val(ui.values[1]);
    },
    change: function(event, ui) {
      var min_price_range = parseInt($(".min_price").val());
      var max_price_range = parseInt($(".max_price").val());
      $('#CollectionSection .grid__item').hide();
      $('#CollectionSection .grid__item').each(function(){
        var productPrice = $(this).attr('data-product-price');

        if(productPrice > min_price_range && productPrice < max_price_range) {
          $(this).show();        
        }else{
          $(this).hide();        
        }        
      });
      var productCount = $('#CollectionSection .grid__item:visible').length;
      $('.collection-filter__item--count').text(productCount +' Products')
    }
  });
  $(".min_price, .max_price").map(function(){
    $(this).on("input", function() {

      updateSlider();
    });
  });
  function updateSlider(){
    $slider.slider("values", [$(".min_price").val(), $(".max_price").val()]);		
  }

});





equalheight = function(container){

  var currentTallest = 0,
      currentRowStart = 0,
      rowDivs = new Array(),
      $el,
      topPosition = 0;
  $(container).each(function() {

    $el = $(this);
    $($el).height('auto')
    topPostion = $el.position().top;

    if (currentRowStart != topPostion) {
      for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
        rowDivs[currentDiv].height(currentTallest);
      }
      rowDivs.length = 0; // empty the array
      currentRowStart = topPostion;
      currentTallest = $el.height();
      rowDivs.push($el);
    } else {
      rowDivs.push($el);
      currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
    }
    for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
      rowDivs[currentDiv].height(currentTallest);
    }
  });
}


$.fn.isInViewport = function() {
  var elementTop = $(this).offset()?.top;
  var elementBottom = elementTop + $(this).outerHeight();

  var viewportTop = $(window).scrollTop();
  var viewportBottom = viewportTop + $(window).height();

  return elementBottom > viewportTop && elementTop < viewportBottom;
};